import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Card,
  CardBody,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Button
} from 'reactstrap';

import no_vouchers from '../../../../../assets/no_vouchers.png';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID, getUserID } from '../../../../../helpers/AxiosAPI';
import {
  gAPI_Vouchers_List, gAPI_Internal_Property_By_Id,
  gAPI_Users_By_Id, gAPI_Vouchers_By_Id,
  gAPI_Invitation_By_Email,
  putAPI_approve_voucher, gAPI_Orders_Voucher
} from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ShowInvitations from './components/forms/ShowInvitations';
import BuyOptionList from './components/BuyOptionList';
import AcceptInvitation from './components/forms/AcceptInvitation';
import moment from 'moment';
import CreateVoucherForm from './components/forms/CreateVouchersForm';
import Pagination from '../../../../../containers/pages/Pagination';
import VoucherListItem from './components/VoucherListItem';
import PurchasedVoucher from './components/PurchasedVouchers';
import ViewOrders from '../orders/Components/ViewOrders';
function Index({ propertyId, locale, currency }) {
  const [voucherList, setVoucherList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [showInvitations, setShowInvitations] = useState(false);
  const [pageSizes, setpageSizes] = useState([10, 15, 20, 25]);
  const [currentPage, setcurrentPage] = useState(1);
  const [SelectedPageSize, setSelectedPageSize] = useState(10);
  const [visible, setVisible] = useState(false);
  const [voucherId, setVoucherId] = useState("");
  const [ispurchaseVoucherVisible, setIsPrchaseVoucherVisible] = useState(false);
  const [propertydata, setPropertyData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [voucherFilter, setVoucherFilter] = useState('');
  const [showRedeem, setShowRedeem] = useState([]);
  const [startDate, setStartDate] = useState(moment().subtract(15, 'days'));
  const [endDate, setEndDate] = useState(moment());
  const [orderList, setOrderList] = useState([]);
  const [showCreateVoucherButton, setShowCreateVoucherButton] = useState(true);
  const [showVoucherList, setShowVoucherList] = useState(true);
  const [dropDown, setDropDown] = useState("");
  const [orderListByNumber, setOrderListByNumber] = useState([]);
  const [orderdataById, setOrderDataById] = useState([]);
  const [showOrderData, setShowOrderData] = useState(false);
  const [inviteVoucher, setinviteVoucher] = useState(false);
  const [SelectedStatus, setSelectedStatus] = useState({
    column: 'All',
    label: 'All',
  });
  const [TotalItems, setTotalItems] = useState(0);
  const [TotalPages, setTotalPages] = useState(1);
  const statusOptions = [
    { column: 'All', label: 'All' },
    { column: 'Active', label: 'Active' },
    { column: 'Draft', label: 'Draft' },
    { column: 'Inactive', label: 'Inactive' },
    { column: 'Archived', label: 'Archived' },
  ];
  const [buyOption, setBuyOption] = useState([]);
  const [isBuyOption, setisBuyOption] = useState(false);
  const [showInvitation, SetShowinvitation] = useState(true);
  const [showApproveInvitation, setShowApproveInvitation] = useState(true);
  const [invitation, setInvitation] = useState({
    'propertyName': 'Abc',
    'propertyId': '',
    'groupId': '',
    'sellFutureVouchers': 'false',
    'invitationId': '',
    'processingFee': 7,
  });
  const [showConnectedVoucher, setShowConnectedVoucher] = useState({
    'groups': [],
    'property': [],
    'id': [],
    'senderGroupId': '',
    'senderPropertyId': '',
    'isShow': false,
    'invitationtype': ''
  });
  const ShowInviteVoucher = (type) => {
    setinviteVoucher(type);
  };
  const handleDropDown = (name) => {
    setDropDown(name);
  }
  const handleVoucherFilter = (name) => {
    setVoucherFilter(name);
  }
  const handleCreateVoucherButtonShow = () => {
    setShowCreateVoucherButton(!showCreateVoucherButton);
  };
  useEffect(() => {
    localStorage.removeItem('Invitation');
    setLoading(true);
    extractData();
  }, [propertyId, search, currentPage, SelectedPageSize, SelectedStatus]);

  const extractData = async () => {
    setBuyOption([]);
    setVoucherList([]);
    await AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
    })
      .then((res) => {
        setUserData(res.data);
        LoadInvitation(getUserID());
        LoadData(getGroupID(), propertyId, res.data.email);
      });
    await AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
    })
      .then((res) => {
        setPropertyData(res.data);
      });
  };

  const LoadInvitation = (email) => {
    let invitation_id = localStorage.getItem("Invitation");
    AxiosAPI({
      url: `${gAPI_Invitation_By_Email}?id=${email}&group_id=${getGroupID()}&property_id=${propertyId}`,
      mehthod: 'get',
    }).then((res) => {
      localStorage.setItem("invitation_data", res.data);
      if (invitation_id !== '') {
        res.data.map((m) => {
          if (m.invitationId === invitation_id) {
            handleConnectedVoucher(m.invitationId, m.groups, m.propertys, m.groupId, m.propertyId, m.type);

          }
        });
      }

      setInvitation(res.data);

    })
      .catch((err) => null);

  };
  const LoadData = (gid, pid, email) => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Vouchers_List}?groupId=${gid === undefined ? getGroupID() : gid}&propertyId=${pid === undefined ? propertyId : pid}&languageCode=${locale}&search=${search}&status=${SelectedStatus.column
        }&pageNumber=${currentPage}&pageSize=${SelectedPageSize}&email=${email !== undefined ? email : userData.email}`,
    })
      .then((res) => {
        setShowVoucherList(true);
        setVoucherList(res.data.vouchers);
        setLoading(false);
        setShowCreateVoucherButton(true);
        setTotalItems(res.data.totalItems);
        setTotalPages(res.data.totalPages);
        if (isBuyOption) {
          let values = [];
          res.data.vouchers.map((m) => {
            if (m.id === voucherId) {
              m.buyOptions.map((item) => {
                values.push(item);
              })
            }
          });
          setBuyOption(values);
        }
      })
      .catch((err) => null);
  };


  const handleBackClick = () => {
    setisBuyOption(false);
    extractData();
  }

  const handleBuyOptionSetings = (value, Id) => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Vouchers_By_Id}/${Id}`,
    }).then((res) => {
      setisBuyOption(true);
      setBuyOption(res.data.sellingOptions);
      setVoucherId(Id);
    });

  }

  const LoadSearchOrderData = (search, data) => {
    setOrderListByNumber([]);
    let temp = [];
    OrderData(data.orderId);
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Orders_Voucher}/search?status=All&search=${search}&groupId=${temp.length > 0 ? temp[0].groupId : getGroupID()}&propertyId=${temp.length > 0 ? temp[0].propertyId : propertyId}`,
    })
      .then(res => {
        setOrderListByNumber(res.data[0]);
        setShowOrderData(true);
      })
      .catch(err => null);
  }

  const changePageSize = (size) => {
    setSelectedPageSize(size);
    setcurrentPage(1);
  };

  const onChangePage = (page) => {
    setcurrentPage(page);
  };

  const changeStatus = (column) => {
    setSelectedStatus(statusOptions.find((x) => x.column === column));
  };

  const onSearchKey = (e) => {
    if (e.key === 'Enter') {
      setSearch(e.target.value.toLowerCase());
    }
  };
  const toggleModal = () => {
    setVisible(!visible);
  };
  const startIndex = (currentPage - 1) * SelectedPageSize;
  const endIndex = currentPage * SelectedPageSize;
  const onOrdersVoucher = () => {
    setIsPrchaseVoucherVisible(true);
    setShowVoucherList(false);
    setLoading(false);
  };

  const handleOrdersVoucherSubmit = () => {
    onOrdersVoucher();
    BindOrders(startDate, endDate, showRedeem, voucherId);
  };
  const handleVoucherPaymentsById = (voucherId, redeem) => {
    let item = voucherList.map((f) => { if (f.id === voucherId) { return (f.name); } });
    onOrdersVoucher();
    setVoucherId(voucherId);
    setDropDown(item);
    setShowCreateVoucherButton(false);
    if (redeem !== undefined && redeem !== 'All') {
      setShowRedeem(redeem);
    }
    let temp = [];
    LoadSearchOrderVoucherData(voucherId, redeem === undefined ? showRedeem : redeem, 'B');
  };
  const handleVoucherPaymentsByIdforthirdParty = (voucherId, redeem, gid, pid) => {
    let item = voucherList.map((f) => { if (f.id === voucherId) { return (f.name); } });
    onOrdersVoucher();
    setVoucherId(voucherId);
    setDropDown(item);
    setShowCreateVoucherButton(false);
    if (redeem !== undefined && redeem !== 'All') {
      setShowRedeem(redeem);
    }
    LoadSearchOrderVoucherData(voucherId, redeem === undefined ? showRedeem : redeem, 'B');
    //LoadSearchOrderVoucherDataForThridParty(voucherId, redeem === undefined ? showRedeem : redeem, 'B', gid, pid);
  };
  const onstartDateChnage = (date) => {
    setStartDate(date);
  };

  const handleSearchfilter = (search) => {
    if (search.length > 0) {
      LoadSearchOrderVoucherData(voucherId, showRedeem, search);
    } else {
      BindOrders(startDate, endDate, showRedeem, voucherId);
    }
  }
  const handleApproval = (id, invitation_id) => {
    let body = ([{
      groupId: getGroupID(), propertyId: propertyId,
      voucherId: id, status: 'Approve'
    }]);
    AxiosAPI({
      url: `${putAPI_approve_voucher}`,
      method: 'put',
      data: { 'VoucherList': body }
    }).then((data) => LoadData())
      .catch((err) => null);
    LoadData();
  };

  const handleReject = (id, invitation_id, status, fee) => {
    let body = ([{
      groupId: getGroupID(), propertyId: propertyId,
      voucherId: id, status: status, invitationId: invitation_id, processingFee: fee
    }]);
    AxiosAPI({
      url: `${putAPI_approve_voucher}`,
      method: 'put',
      data: { 'voucherList': body }
    }).then((data) => LoadData())
      .catch((err) => null);

  };
  const onEndDateChnage = (date) => {
    setEndDate(date);
  };

  function BindOrders(startdate, enddate, redeem, voucherId) {
    setOrderList([]);
    let fromDate = startdate ? startDate.format('YYYY-MM-DD') + ' 00:00:00' : '';
    let toDate = enddate ? endDate.format('YYYY-MM-DD') + ' 23:59:59' : '';
    let temp = [];
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Orders_Voucher}/voucher?redeem=${redeem}&voucherId=${voucherId}&fromDate=${fromDate}&toDate=${toDate}&groupId=${temp.length > 0 ? temp[0].groupId : getGroupID()}&propertyId=${temp.length > 0 ? temp[0].propertyId : propertyId}`,
    })
      .then(res => {
        setOrderList(res.data);
      })
      .catch(err => null);
  }

  const handleConnectedVoucher = (id, groups, property, senderGroup, senderProperty, type) => {
    setShowConnectedVoucher({
      groups: groups, property: property, id: id, isShow: true, senderGroupId: senderGroup,
      senderPropertyId: senderProperty, invitationtype: type
    });
  };

  const LoadSearchOrderVoucherData = (voucherId, redeem, search) => {
    setOrderList([]);
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Orders_Voucher}/search/voucher?redeem=${redeem}&voucherId=${voucherId}&search=${search}&groupId=${getGroupID()}&propertyId=${propertyId}`,
    })
      .then(res => {

        setOrderList(res.data);
        setLoading(false);
      })
      .catch(err => null);
  }
  const LoadSearchOrderVoucherDataForThridParty = (voucherId, redeem, search, gid, pid) => {
    setOrderList([]);
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Orders_Voucher}/search/voucher?redeem=${redeem}&voucherId=${voucherId}&search=${search}&groupId=${gid}&propertyId=${pid}`,
    })
      .then(res => {

        setOrderList(res.data);
        setLoading(false);
      })
      .catch(err => null);
  }
  const handleRedeemVoucher = (number) => {
    if (number !== undefined || null) {
      let date = moment();
      let redeemdate = date.format('YYYY-MM-DD HH:mm:ss');

      AxiosAPI({
        method: 'PUT',
        url: `${gAPI_Orders_Voucher}/voucher/redeem?id=00000000-0000-0000-0000-000000000000&voucherNumber=${number}&redeemDate=${redeemdate}`,
      })
        .then(res => {

          if (res.data.redeem) {
            LoadSearchOrderVoucherData(voucherId, showRedeem, 'BMB');
          }
        })
        .catch(err => null);
    }
  };
  const OrderData = (id) => {
    setOrderDataById([]);
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Orders_Voucher}/detail?orderId=${id}`,
    })
      .then(res => {
        setOrderDataById(res.data.items);
      })
      .catch(err => null);
  }
  const handleBack = () => {
    LoadData();
    setIsPrchaseVoucherVisible(!ispurchaseVoucherVisible);
  }
  return (
    <Fragment>
      <Row className="survey-app">
        <Colxx xxs="12">
          {/* */}
          {/* {loading !== undefined && !loading && showCreateVoucherButton && invitation.length > 0 && invitation.filter((m) =>
            m.sellerPropertyId === propertyId && m.type !== 'Sell' && voucherList.filter((v) => v.invitationId === m.invitationId && v.approvalStatus === '1').length > 0
          ).length > 0 &&
            < p className='col-md-12 text-center my-3' onClick={() => setShowInvitations(!showInvitations)}>
              You have 3rd party vouchers awaiting your approval. Click <span className='voucher-preview' >here</span> to review. </p>
          } */}

          {/* {invitation.length > 0 && invitation.filter((f) => f.status === 'Active').length > 0
            && < p className='col-md-12 text-center my-3' onClick={() => window.location.reload()}>You have vouchers pending
              for review, click <span className='voucher-preview' >here</span>...</p>} */}

          <div className="mb-2">
            {loading !== undefined && !loading && showCreateVoucherButton && <CreateVoucherForm voucherId={voucherId}
              propertyId={propertyId}
              userData={userData}
              ShowInviteVoucher={ShowInviteVoucher}
              inviteVoucher={inviteVoucher}
              propertydata={propertydata}
              handleBuyOptionSetings={handleBuyOptionSetings}
              locale={locale}
              handleConnectedVoucher={handleConnectedVoucher}
              invitation={invitation}
              voucherList={voucherList}
              isBuyOption={isBuyOption}
              LoadData={LoadData} />}
          </div>
        </Colxx>

      </Row>
      {
        voucherList !== undefined && !isBuyOption && (voucherList.length > 1 && showVoucherList) ?
          <Fragment>
            <Row>
              <Colxx xxs="4">
                <div className="mb-2">
                  <div className="d-block d-md-inline-block">
                    <UncontrolledDropdown className="mr-1 float-md-left btn-group mb-1">
                      <DropdownToggle caret color="outline-dark" size="xs">
                        Status
                        {SelectedStatus.label}
                      </DropdownToggle>
                      <DropdownMenu>
                        {statusOptions.map((order, index) => {
                          return (
                            <DropdownItem
                              key={index}
                              onClick={() => changeStatus(order.column)}
                            >
                              {order.label}
                            </DropdownItem>
                          );
                        })}
                      </DropdownMenu>
                    </UncontrolledDropdown>
                    <div className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top">
                      <input
                        type="text"
                        name="keyword"
                        id="search"
                        placeholder="Search"
                        onKeyPress={(e) => onSearchKey(e)}
                      />
                    </div>
                  </div>
                </div>
              </Colxx>
              <Colxx xxs="8">
                <div className="float-md-right">
                  <span className="text-muted text-small mr-1">{`${startIndex}-${endIndex} of ${TotalItems} `}</span>
                  <UncontrolledDropdown className="d-inline-block">
                    <DropdownToggle caret color="outline-dark" size="xs">
                      {SelectedPageSize}
                    </DropdownToggle>
                    <DropdownMenu right>
                      {pageSizes.map((size, index) => {
                        return (
                          <DropdownItem
                            key={index}
                            onClick={() => changePageSize(size)}
                          >
                            {size}
                          </DropdownItem>
                        );
                      })}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </Colxx>
            </Row>
            <Separator className="mb-5" />
          </Fragment> : ""
      }

      {
        isBuyOption && (<Colxx xxs="10" md="2" className="">
          <a onClick={() => { handleBackClick(); }}>
            <h1 class="iconsminds-back"></h1></a>
        </Colxx>)
      }
      {
        showVoucherList !== undefined && !showConnectedVoucher.isShow && !isBuyOption && showVoucherList && (<Row className="col-md-12" >
          {loading !== undefined && !loading ? (voucherList !== undefined && voucherList.length > 0 ?
            voucherList.map((item, index) => {
              item.sellingOptions = item.buyOptions
              return (
                <VoucherListItem
                  key={`guest_item_${index}`}
                  item={item}
                  handleApproval={handleApproval}
                  toggleModal={toggleModal}
                  LoadData={LoadData}
                  handleReject={handleReject}
                  handleVoucherPaymentsByIdforthirdParty={handleVoucherPaymentsByIdforthirdParty}
                  isBuyOption={isBuyOption}
                  propertyId={propertyId}
                  ShowInviteVoucher={ShowInviteVoucher}
                  inviteVoucher={inviteVoucher}
                  invitation={invitation}
                  voucherList={voucherList}
                  propertydata={propertydata}
                  extractData={extractData}
                  currency={currency}
                  handleVoucherFilter={handleVoucherFilter}
                  handleBuyOptionSetings={handleBuyOptionSetings}
                  handleVoucherPaymentsById={handleVoucherPaymentsById}
                />
              );
            })
            : <div className="d-flex justify-content-center col-md-12"> <img src={no_vouchers} alt=""></img></div>
          ) : (
            <div className="loading" />
            //
          )
          }

        </Row >)
      }
      <Row className="col-md-12">
        {isBuyOption &&
          buyOption.map((item, index) => {
            return (
              <BuyOptionList
                key={`guest_item_${index}`}
                item={item}
                toggleModal={toggleModal}
                LoadData={LoadData}
                propertyId={propertyId}
                isBuyOption={isBuyOption}
                currency={currency}
                extractData={extractData}
                voucherId={voucherId}
              />
            );
          })
        }

      </Row>
      <Row className="col-md-12">
        {ispurchaseVoucherVisible ?
          <PurchasedVoucher
            loading={loading}
            onstartDateChange={onstartDateChnage}
            onEndDateChange={onEndDateChnage}
            handleSubmit={handleOrdersVoucherSubmit}
            orderList={orderList}
            handleBack={handleBack}
            handleSearchfilter={handleSearchfilter}
            handleVoucherPaymentsById={handleVoucherPaymentsById}
            handleVoucherPaymentsByIdforthirdParty={handleVoucherPaymentsByIdforthirdParty}
            voucherList={voucherList}
            handleDropDown={handleDropDown}
            handleRedeemVoucher={handleRedeemVoucher}
            dropDown={dropDown}
            voucherFilter={voucherFilter}
            handleVoucherFilter={handleVoucherFilter}
            showRedeem={showRedeem}
            voucherId={voucherId}
            locale={locale}
            propertydata={propertydata}
            LoadSearchOrderData={LoadSearchOrderData}
            handleCreateVoucherButtonShow={handleCreateVoucherButtonShow}
          />
          : (
            <div className="" />
          )}
      </Row>
      <Row>
        {!isBuyOption && <Pagination
          currentPage={currentPage}
          totalPage={TotalPages}
          onChangePage={(i) => onChangePage(i)}
        />
        }
      </Row>

      {
        showOrderData ? <Fragment>
          <ViewOrders
            isopen={showOrderData}
            toggle={() => { setShowOrderData(false) }}
            orderData={orderdataById}
            subOrderList={orderListByNumber}
          />
        </Fragment> : ""
      }
      {
        invitation.length > 0 && invitation.map((i) => {
          if (i.status === 'Active') {
            return (<AcceptInvitation isVisible={showInvitation} propertyId={propertyId}
              propertydata={propertydata} invitation={i} LoadData={LoadData} handleConnectedVoucher={handleConnectedVoucher}
              toggle={() => SetShowinvitation(!showInvitation)} />);
          }
        })
      }
      {
        showInvitations && <ShowInvitations propertyId={propertyId} voucherList={voucherList}
          handleConnectedVoucher={handleConnectedVoucher} hideModal={() => setShowInvitations(!showInvitations)} invitations={invitation} showModal={showInvitations}></ShowInvitations>
      }
    </Fragment >
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale, currency } = settings;
  return {
    propertyId,
    locale,
    currency,
  };
};

export default injectIntl(connect(mapStateToProps, {})(Index));
